import http from './http';

export async function getAvailabelPlans() {
  const res = await http.get(`/plans/available`);
  return res.data?.data ?? res.data;
}

export async function createSubscription(data) {
  const res = await http.post(`/shop/subscription`, data);
  return res.data?.data ?? res.data;
}

export async function getPlanByCode(code) {
  const plans = await getAvailabelPlans();
  return plans.find(p => p.code?.toUpperCase() === code?.toUpperCase()) ?? null;
}